import React, { useEffect, useState } from 'react';
import { SimpleView, CompositeView, GridView } from '@digital/ui';

import DemandasAndamento from './DemandasAndamento';
import DemandasConcluido from './DemandasConcluido';

const AcervoDemandante = async () => {
  return (
    <SimpleView>
      <CompositeView>
        <GridView icon="ui-in_progress" title="Em Andamento" id="andamento">
          <DemandasAndamento></DemandasAndamento>
        </GridView>
        <GridView icon="ui-offline_pin" title="Concluídos / Cancelados" id="concluido">
          <DemandasConcluido></DemandasConcluido>
        </GridView>
      </CompositeView>
    </SimpleView>
  );
};
export default AcervoDemandante;
